import type { RichTextEditorProps } from "@hightouch/formkit";
import { Box, Column } from "@hightouch/htui";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Editor } from "src/components/editor";
import type { SharedProps } from ".";
import { FormkitRTE } from "src/formkit/components/rich-text-editor";
import { Controller } from "react-hook-form";

export const FKRichTextEditor = ({
  name,
  placeholder,
  profile,
  handler,
  isDisabled,
}: RichTextEditorProps & SharedProps) => {
  const { enableSlackRte } = useFlags();

  const basicRenderer = ({ field }) => (
    <Column
      borderWidth="hairline"
      borderStyle="solid"
      borderColor="base.border"
      borderRadius="md"
      maxHeight="300px"
      minHeight="200px"
      height="100%"
      overflow="hidden"
    >
      <Editor
        minHeight="200px"
        readOnly={isDisabled}
        value={field.value || ""}
        language="liquid"
        placeholder={placeholder}
        onChange={field.onChange}
      />
    </Column>
  );

  const rteRenderer = ({ field }) => (
    <Box
      borderWidth="hairline"
      borderStyle="solid"
      borderColor="base.border"
      borderRadius="md"
    >
      <FormkitRTE
        isDisabled={isDisabled}
        onChange={field.onChange}
        value={field.value}
        profile={profile}
        placeholder={placeholder}
        handler={handler}
      />
    </Box>
  );

  return (
    <Controller
      name={name}
      render={enableSlackRte ? rteRenderer : basicRenderer}
    />
  );
};
